module.exports = __webpack_public_path__ + "static/rod_of_absorption-bfe9088c92444834a30d5ea32de7aa0c.jpeg";